export default function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
      <div>
        {eyebrow && (
          <div className="text-xs font-bold uppercase tracking-[0.14em] text-slate-500 mb-3">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
          {title}
        </h1>
        {description && (
          <p className="mt-3 text-slate-500 max-w-2xl leading-relaxed">{description}</p>
        )}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}
